//Include Both Helper File with needed methods

import { postVendorRegister, getRegistrationCode, getAffiliateRegistrationCode, postAffiliateRegister } from "../../../helpers/backend_helper"

// action
import {
  registerUserSuccessful,
  registerUserFailed,
  resetRegisterFlagChange,
  registrationCodeRequest,
  registrationCodeSuccess,
  registrationCodeError,
  resetRegistrationCodeFlag,
  // apiErrorChange
} from "./reducer"

// Is user register successfull then direct plot user in redux.
export const registerUser = (user: any) => async (dispatch: any) => {
  try {
    const response = await postVendorRegister(user)
    console.log("Registration response:", response)
    const data: any = response

    if (data.vendor || data.status === "pending_approval" || data.success === true) {
      console.log("[v0] Registration successful, dispatching success action")
      dispatch(registerUserSuccessful(data))
      return { success: true, vendor: data.vendor, data }
    } else {
      console.log("[v0] Registration failed, dispatching failed action")
      dispatch(registerUserFailed(data.message || "Registration failed"))
      return { success: false, message: data.message }
    }
  } catch (error: any) {
    console.log("[v0] Registration error:", error)
    const errorMessage = error?.response || error?.message || "Registration failed. Please try again."
    dispatch(registerUserFailed(errorMessage))
    return { success: false, message: errorMessage }
  }
}
export const registerAffiliateUser = (user: any) => async (dispatch: any) => {
  try {
    let response = await postAffiliateRegister(user)
    console.log("Registration response:", response)
    const data: any = response

    if (data.success === true) {
      console.log("[v0] Registration successful, dispatching success action")
      dispatch(registerUserSuccessful(data))
      return data // Return the full response data on success
    } else {
      console.log("[v0] Registration failed, dispatching failed action")
      // Dispatch the failure with the message (if one exists)
      dispatch(registerUserFailed(data.message || "Registration failed"))
      
      // *** THE CRUCIAL CHANGE: Return the full data instead of throwing a generic Error ***
      return data // Return the full API error body (e.g., the object with the 'errors' field)
    }
  } catch (error: any) {
    // This catch block handles actual network or HTTP errors (4xx/5xx)
    console.log("[v0] Registration error:", error)
    // Your api_helper.ts is set up to return the error body here,
    // so it's best to re-throw the original error for the component to handle.
    const errorMessage = error?.response || error?.message || "Registration failed. Please try again."
    console.log(errorMessage)
    dispatch(registerUserFailed(errorMessage))
    throw error
  }
}

export const resetRegisterFlag = () => {
  try {
    const response = resetRegisterFlagChange()
    return response
  } catch (error) {
    return error
  }
}

export const sendRegistrationCode = (email: string) => async (dispatch: any) => {
  try {
    dispatch(registrationCodeRequest())

    const response = await getRegistrationCode({ email })

    if (response?.success) {
      dispatch(registrationCodeSuccess(response as any))
      return { success: true, message: response.message }
    }

    // API returned 2xx but with error content e.g. {"errors":{"email":["The email has already been taken."]}}
    const fieldError = response?.errors?.email?.[0]
      || (response?.errors ? (Object.values(response.errors) as string[][])[0]?.[0] : null)
    const fallbackMsg = fieldError || response?.message || "Failed to send verification code"
    dispatch(registrationCodeError(fallbackMsg))
    return { success: false, message: fallbackMsg }
  } catch (error: any) {
    const fieldError = error?.errors?.email?.[0]
      || (error?.errors ? (Object.values(error.errors) as string[][])[0]?.[0] : null)
    const errorMessage = fieldError || error?.message || "Failed to send verification code"
    dispatch(registrationCodeError(errorMessage))
    return { success: false, message: errorMessage }
  }
}
export const sendAffiliateRegistrationCode = (email: string) => async (dispatch: any) => {
  try {
    dispatch(registrationCodeRequest())

    const response = await getAffiliateRegistrationCode({ email })

    if (response) {
      // cast to any to satisfy action payload typing when the action expects void/union
      dispatch(registrationCodeSuccess(response as any))
      return response
    }
  } catch (error: any) {
    const errorMessage = error?.response?.data?.message || error?.message || "Failed to send registration code"
    dispatch(registrationCodeError(errorMessage))
    throw error
  }
}

export const resetRegistrationCode = () => {
  try {
    const response = resetRegistrationCodeFlag()
    return response
  } catch (error) {
    return error
  }
}

// export const apiError = () => async (dispatch : any) => {
//   try {
//     const response = dispatch(apiErrorChange(false));
//     return response;
//   } catch (error) {
//     return error;
//   }
// };
